import React from "react";
import ReactS3Uploader from "react-s3-uploader";
import { Form, Button } from "antd";

const UploadForm = Form.create()(
  class C extends React.Component {
    state = {
      percentage: undefined,
      success: undefined,
      upload: undefined,
    };

    uploaderRef = React.createRef();

    handlePreprocess = (file, next) => next(file);

    handleGetSignedUrl = async (file, uploadToS3Callback) => {
      const { onGenerateUploadUrl } = this.props;
      const signedUrl = await onGenerateUploadUrl({ file });

      if (!signedUrl) {
        this.setState({ success: false });
        return;
      }

      this.setState({ success: undefined });
      uploadToS3Callback({ signedUrl });
    };

    handleProgress = (percentage, status, file) =>
      this.setState({ percentage });

    handleError = (error, file) => this.setState({ success: false });

    handleFinish = (signResult, file) => {
      const { onHappened } = this.props;
      const publicUrl = signResult.signedUrl.split("?")[0];
      const upload = { signResult, publicUrl, file };
      onHappened(upload);
      this.setState({ upload });
    };

    handleSubmit = (e) => {
      const { onFinished } = this.props;
      const { upload } = this.state;
      e.preventDefault();
      onFinished(upload);
    };

    render() {
      const { percentage, success, upload } = this.state;

      return (
        <Form onSubmit={this.handleSubmit} autoComplete="off" layout="vertical">
          <Form.Item
            label="File"
            required={true}
            {...(percentage !== undefined && {
              help: `${percentage}% ${
                percentage !== 100 ? "and counting" : "done"
              }`,
            })}
            {...(success === false && {
              validateStatus: "error",
              help: "Something went wrong ... try again",
            })}
          >
            <ReactS3Uploader
              ref={this.uploaderRef}
              disabled={percentage !== undefined || success === true}
              getSignedUrl={this.handleGetSignedUrl}
              preprocess={this.handlePreprocess}
              onProgress={this.handleProgress}
              onError={this.handleError}
              onFinish={this.handleFinish}
              // FIXME: this has to be set both on the server while generating
              // the presigned url and from the client while uploading ...
              // So actually, it would make sense to have the call to get the
              // signed url return additional needed headers too.
              uploadRequestHeaders={{ "Cache-Control": "max-age=315360000" }}
              contentDisposition="auto"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" disabled={!upload}>
              Close
            </Button>
          </Form.Item>
        </Form>
      );
    }
  }
);

export default UploadForm;
